"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsPreset = void 0;
const tsenum_1 = require("@gradecam/tsenum");
exports.OptionsPreset = tsenum_1.MakeEnum({
    Default: 'default',
    LowObfuscation: 'low-obfuscation',
    MediumObfuscation: 'medium-obfuscation',
    HighObfuscation: 'high-obfuscation'
});
